import {
  ArrowRight,
  Bell,
  Check,
  ChevronDown,
  Cpu,
  FileText,
  Fuel,
  Gauge,
  Globe,
  HardHat,
  MapPin,
  Menu,
  Minus,
  Moon,
  Package,
  Phone,
  Play,
  Radar,
  Route,
  ShieldCheck,
  Smartphone,
  Star,
  Sun,
  Thermometer,
  Truck,
  Wrench,
  X,
  Zap,
  type LucideIcon,
} from 'lucide-react';

export const ICONS = {
  truck: Truck,
  pin: MapPin,
  fuel: Fuel,
  shield: ShieldCheck,
  phone: Smartphone,
  wrench: Wrench,
  file: FileText,
  bell: Bell,
  zap: Zap,
  check: Check,
  arrow: ArrowRight,
  sun: Sun,
  moon: Moon,
  globe: Globe,
  temp: Thermometer,
  gauge: Gauge,
  radar: Radar,
  chev: ChevronDown,
  x: X,
  menu: Menu,
  package: Package,
  hat: HardHat,
  cpu: Cpu,
  minus: Minus,
  star: Star,
  play: Play,
  call: Phone,
  route: Route,
} satisfies Record<string, LucideIcon>;

export type LpIconName = keyof typeof ICONS;

/** Inline Lucide icon sized by the `.i` class (1em) — `flip` mirrors it in RTL (arrows). */
export function Ic({ name, flip = false, className }: { name: LpIconName; flip?: boolean; className?: string }) {
  const C = ICONS[name];
  return <C className={className ?? (flip ? 'i flip' : 'i')} aria-hidden="true" focusable="false" />;
}
